module.exports = __webpack_public_path__ + "img/PDF@3x.52a19757.png";